import React, { useMemo } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useAppUser } from "../../../contexts/user-context/UserContext";
import SideNavBar from "../components/side-nav-bar/SideNavBar";
import NavBarMobile from "../components/nav-bar-mobile/NavBarMobile";
import "./styles.scss";
import Account from "./account/containers/Account";
import Home from "./home/containers/Home";
import LibraryRoutes from "./library/containers/LibraryRoutes";
import Calender from "./calendar/containers/Calendar";
import Inbox from "./inbox/containers/Inbox";
import Help from "./help/containers/Help";
import UpdateWorkshop from "./update-workshops/containers/UpdateWorkshop";
import Login from "../../login/container";
import StudentWorkshop from "./student-workshop-view/containers/StudentWorkshop";
import PublicLibrary from "./public/containers/PublicLibrary";
import UpdatePublicWorkshop from "./update-public-workshops/containers/UpdatePublicWorkshop";
import Mentoring from "../../mentoring/containers/Mentoring";
import AnnouncementRoutes from "./announcements/AnnouncementRoutes";
import CreateAnnouncement from "./announcements/create-announcement/CreateAnnouncement";
import AnnouncementRoutesMember from "./announcements/AnnouncementRoutesMember";
import AlumniRoutesAdmin from "./alumni-admin/AlumniRoutesAdmin";
import TeamsRoutes from "./teams/containers/TeamRoutes";
import ArchevedLibrary from "./archive/containers/ArchivedLibrary";
import MainDashboard from "./dashboard/containers/Dashboard";
import { UserPrivilege } from "../../../shared/constants/Constant";

export enum DashboardPages {
  HOME = "/dashboard/home",
  ACCOUNT = "/dashboard/account",
  LIBRARY = "/dashboard/library",
  CALENDAR = "/dashboard/calendar",
  INBOX = "/dashboard/inbox",
  HELP = "/dashboard/help",
  TEAMS = "/dashboard/teams",
  WORKSHOP = "/dashboard/workshops/:id",
  ARCHIVED_WORKSHOP = "/dashboard/archived/workshops/:id",
  DIRECT_ARCHIVED_WORKSHOP = "/dashboard/archived/direct/workshops/:id",
  WORKSHOP_EDIT = "/dashboard/workshops/:id/edit",
  PUBLIC_WORKSHOP = "/dashboard/public/workshops/:id",
  PUBLIC_WORKSHOP_EDIT = "/dashboard/public/workshops/:id/edit",
  PUBLIC = "/dashboard/public/library",
  MENTORING = "/dashboard/sessions",
  ANNOUNCEMENTS = "/dashboard/announcements",
  ANNOUNCEMENTS_CREATE = "/dashboard/announcements/newannouncement",
  ALUMNI = "/dashboard/alumni",
  ARCHIVED_WORKSHOPS = "/dashboard/archived",
  DASHBOARD = "/dashboard",
}

const Dashboard = () => {
  const { fireUser, userRole, permissions } = useAppUser();

  return useMemo(() => {
    return (
      <div>
        <SideNavBar />
        <NavBarMobile />
        <div className="main-content-wrapper">
          <Switch>
            <Route path={DashboardPages.ACCOUNT} component={Account} />
            <Route
              path={DashboardPages.DASHBOARD}
              exact
              component={MainDashboard}
            />
            <Route path={DashboardPages.CALENDAR} component={Calender} />

            <Route
              path={DashboardPages.LIBRARY}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return <LibraryRoutes />;
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  userRole.isMember
                ) {
                  if (
                    permissions.find(
                      (p) => p.privilege === UserPrivilege.LIBRARY
                    )
                  ) {
                    return <LibraryRoutes />;
                  } else {
                    return <Redirect to={DashboardPages.ACCOUNT} />;
                  }
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              path={DashboardPages.PUBLIC}
              component={() => <PublicLibrary />}
            />
            <Route
              path={DashboardPages.MENTORING}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return <Mentoring />;
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  userRole.isMember
                ) {
                  if (
                    permissions.find(
                      (p) => p.privilege === UserPrivilege.MENTORS
                    )
                  ) {
                    return <Mentoring />;
                  } else {
                    return <Redirect to={DashboardPages.ACCOUNT} />;
                  }
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              path={DashboardPages.ALUMNI}
              component={() => <AlumniRoutesAdmin />}
            />
            <Route path={DashboardPages.INBOX} component={Inbox} />
            <Route path={DashboardPages.HELP} component={Help} />
            <Route
              path={DashboardPages.HOME}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return <Home />;
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  userRole.isMember
                ) {
                  return <Redirect to={DashboardPages.LIBRARY} />;
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              path={DashboardPages.TEAMS}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return <TeamsRoutes />;
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  !userRole.isMember
                ) {
                  return <Login />;
                } else {
                  return <Redirect to={DashboardPages.ACCOUNT} />;
                }
              }}
            />
            <Route
              path={DashboardPages.WORKSHOP}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return (
                    <UpdateWorkshop
                      isArchived={false}
                      isDireactArchived={false}
                    />
                  );
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  userRole.isMember
                ) {
                  if (
                    permissions.find(
                      (p) => p.privilege === UserPrivilege.LIBRARY
                    )
                  ) {
                    return <StudentWorkshop isArchived={false} />;
                  } else {
                    return <Redirect to={DashboardPages.ACCOUNT} />;
                  }
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              path={DashboardPages.WORKSHOP_EDIT}
              exact
              component={UpdateWorkshop}
            />
            <Route
              path={DashboardPages.PUBLIC_WORKSHOP}
              component={() => {
                if (fireUser && userRole.isMember) {
                  return <UpdatePublicWorkshop />;
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              path={DashboardPages.PUBLIC_WORKSHOP_EDIT}
              exact
              component={UpdatePublicWorkshop}
            />
            <Route
              path={DashboardPages.ANNOUNCEMENTS}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return <AnnouncementRoutes />;
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  userRole.isMember
                ) {
                  if (
                    permissions.find(
                      (p) => p.privilege === UserPrivilege.NOTICES
                    )
                  ) {
                    return <AnnouncementRoutesMember />;
                  } else {
                    return <Redirect to={DashboardPages.ACCOUNT} />;
                  }
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              path={DashboardPages.ANNOUNCEMENTS_CREATE}
              component={CreateAnnouncement}
            />
            <Route
              exact
              path={DashboardPages.ARCHIVED_WORKSHOP}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return (
                    <UpdateWorkshop
                      isArchived={true}
                      isDireactArchived={false}
                    />
                  );
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  userRole.isMember
                ) {
                  if (
                    permissions.find(
                      (p) => p.privilege === UserPrivilege.LIBRARY
                    )
                  ) {
                    return <StudentWorkshop isArchived={true} />;
                  } else {
                    return <Redirect to={DashboardPages.ACCOUNT} />;
                  }
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              exact
              path={DashboardPages.DIRECT_ARCHIVED_WORKSHOP}
              component={() => {
                if (fireUser && userRole.isModerator) {
                  return (
                    <UpdateWorkshop
                      isArchived={true}
                      isDireactArchived={true}
                    />
                  );
                } else if (
                  fireUser &&
                  !userRole.isModerator &&
                  userRole.isMember
                ) {
                  return <Redirect to={DashboardPages.ACCOUNT} />;
                } else {
                  return <></>;
                }
              }}
            />
            <Route
              path={DashboardPages.ARCHIVED_WORKSHOPS}
              component={() => {
                if (
                  permissions.find((p) => p.privilege === UserPrivilege.LIBRARY)
                ) {
                  return <ArchevedLibrary />;
                } else {
                  return <Redirect to={DashboardPages.ACCOUNT} />;
                }
              }}
            />
          </Switch>
        </div>
      </div>
    );
  }, [fireUser, userRole, permissions]);
};

export default Dashboard;
